import React, { createContext, useContext, useState, ReactNode } from "react";

interface CopyNotifProviderProps {
  children: ReactNode; // Указываем тип для children
}

interface CopyNotifContextType {
  components: { id: number }[];
  counter: number;
  addCopyComponent: () => void;
  removeCopyComponent: (id: number) => void;
}

const CopyNotifContext = createContext<CopyNotifContextType | undefined>(
  undefined
);

export const CopyNotifProvider: React.FC<CopyNotifProviderProps> = ({
  children,
}) => {
  const [components, setComponents] = useState<{ id: number }[]>([]);
  const [counter, setCounter] = useState(0);

  const addCopyComponent = () => {
    const newId = counter;
    setComponents((prevComponents) => [...prevComponents, { id: newId }]);
    setCounter(counter + 1);
  };

  const removeCopyComponent = (id: number) => {
    setComponents((prevComponents) =>
      prevComponents.filter((comp) => comp.id !== id)
    );
  };

  return (
    <CopyNotifContext.Provider
      value={{ components, counter, addCopyComponent, removeCopyComponent }}
    >
      {children}
    </CopyNotifContext.Provider>
  );
};

export const useCopyNotif = () => {
  const context = useContext(CopyNotifContext);
  if (!context) {
    throw new Error("useCopyNotif must be used within a CopyNotifProvider");
  }
  return context;
};
